import Api from "../../axios"

export const getShortDayList= async ({id,startDate, endDate})=>{
    return await Api.get(`/short_days_list?start_date=${startDate}&end_date=${endDate}&employee_id=${id}`)
}